import { Genv } from './global';
class WPapiClass {
    constructor() {
        this.running = false;
        this.method_ = "POST"
        this.ajaxObject = (window.ajax_object) ? window.ajax_object : { ajax_url: "https://dev.owl360.com.co/admin-ajax.php", "nonce": "" }
    }
    method(method_) {
        this.method_ = method_;
        return this;
    }
    get class() {
        return this;
    }
    async go(action, data, nameParam = "data") {
        return await this.ajax(action, data, nameParam);
    }
    async call(action, data, nameParam = "data") {
        console.log("api Call:", action)
        return await this.ajax(action, data, nameParam);
    }
    prepareApiData(data_) {

        const formData = new FormData();
        let data = {}

        function appendFormData(cdata, sdata) {
            for (const [key, value] of Object.entries(cdata)) {
                if (value instanceof File) {
                    formData.append(key, value);
                } else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    sdata[key] = {}
                    appendFormData(value, sdata[key]);
                } else {
                    sdata[key] = value;
                }
            }
        }

        if (typeof data_ === 'object') appendFormData(data_, data);
        else data = data_;
        formData.append('data', JSON.stringify(data));
        console.log("data send:", data)

        return formData;
    }
    async ajax(action, data) {
        this.showRunning(true);

        let formData = new FormData();
        if (data instanceof FormData) formData = data;
        else formData = this.prepareApiData(data)

        // eslint-disable-next-line
        const ajaxParams = { url: this.ajaxObject.ajax_url, nonce: this.ajaxObject.nonce };

        formData.append('action', action);
        formData.append('security', ajaxParams.nonce);

        const response = await fetch(ajaxParams.url, {
            method: this.method_,
            credentials: 'same-origin',
            body: formData
        });

        if (response && response.status == 200) {
            let st = await response.json();
            if (st.success) {
                this.showRunning(false);
                console.log(`${action} called successfully`);
                console.log("WP Api call:", st);
                if (st.data.callBack) {
                    console.log("callBack:", st.data.callBack);
                    Genv.eventBus.emit("redirectPage", { 'callBack': st.data.callBack, 'msgCallBack': st.data.msgCallBack, 'btnCallBack': st.data.btnCallBack });
                }
                return (st.data) ? {...st.data, "status": true } : st;
            } else {
                this.showRunning(false);
                Genv.eventBus.emit("newMessage", { 'msg': (st.data && st.data.msg) ? st.data.msg : "No logro grabar el registro"  , time: 30 });
                console.error(`Error calling ${action}`, st);
                return { status: false, error: st };
            }
        } else {
            this.showRunning(false);
            console.error(`${action} Error: ${response.status}`);
            return { status: false, error: "Error:" + response.status };
        }
        

    }

    createSpinner() {
        const existingSpinner = document.getElementById('loading-indicator');
        const existingShield = document.getElementById('screen-shield');

        if (existingSpinner && existingShield) {
            this.running = existingSpinner;
            return;
        }

        const shield = document.createElement('div');
        shield.id = 'screen-shield';
        shield.style.position = 'fixed';
        shield.style.top = '0';
        shield.style.left = '0';
        shield.style.width = '100%';
        shield.style.height = '100%';
        shield.style.backgroundColor = 'rgba(0, 0, 0, 0.7)'; // Gris oscuro transparente al 70%
        shield.style.zIndex = '999';
        shield.classList.add('d-none'); // Inicialmente oculto

        const spinner = document.createElement('div');
        spinner.className = 'spinner-border text-primary position-fixed d-none';
        spinner.style.zIndex = '1000';
        spinner.style.margin = '10px'; // Márgenes para posicionarlo adecuadamente
        spinner.id = 'loading-indicator';

        document.body.appendChild(shield);
        document.body.appendChild(spinner);

        this.running = spinner;
        this.shield = shield;
    }

    updatePosition() {
        if (this.running) {
            if (!Genv.mouse) Genv.mouse = { x: 0, y: 0 }
            let { x, y } = Genv.mouse;
            this.running.style.top = (y + 25) + 'px';
            this.running.style.left = (x + 25) + 'px';
        }
    }

    showRunning(show) {
        if (!this.running) {
            this.createSpinner();
        }

        if (show) {
            this.updatePosition();
            this.shield.classList.remove('d-none');
            this.running.classList.remove('d-none');
        } else {
            this.shield.classList.add('d-none');
            this.running.classList.add('d-none');
        }
    }




}
const apiLoaded = new WPapiClass();
const ajax = apiLoaded.ajax.bind(apiLoaded)
const $api = apiLoaded.class
const prepareApiData = apiLoaded.prepareApiData
Genv.$api = $api;
Genv.$prepareApiData = prepareApiData
export {
    ajax,
    $api,
    prepareApiData
};